import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { DASHBOARD_ROUTE_PATHS } from './config';

export const DASHBOARD_ROUTES: TApplicationRoute[] = [
  {
    id: 'dashboard',
    path: DASHBOARD_ROUTE_PATHS.dashboard,
    component: lazy(() => import('./pages/dashboard-page')),
    // Protected route (not marked as isPublic) - will use DefaultLayout by default
    layout: 'default',
    permissions: {
      scopes: [],
    },
  },
  {
    id: 'dashboard-fullscreen',
    path: DASHBOARD_ROUTE_PATHS.dashboardFullScreen,
    component: lazy(() => import('./pages/dashboard-page')), // Same component, different layout
    // Protected route (not marked as isPublic) but explicitly uses EmptyLayout
    layout: 'empty', // Override default rule to use EmptyLayout (no header/footer)
    permissions: {
      scopes: [],
    },
  },
];
